"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _class, _descriptor, _temp;

var ShowOnline = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(ShowOnline, _Component);

  function ShowOnline() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, ShowOnline);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(ShowOnline)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "profile", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.state = {
      showOnline: _this.profile.showOnline
    };
    return _this;
  }

  babelHelpers.createClass(ShowOnline, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.profile != this.props.profile) {
        this.setState({
          showOnline: this.props.profile.showOnline
        });
      }
    }
  }, {
    key: "setShowOnline",
    value: function setShowOnline(event) {
      this.setState({
        showOnline: event.target.checked
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        "data-field": "showOnline",
        className: "form-group checkbox"
      }, _react.default.createElement("label", null, _react.default.createElement("span", {
        className: "checkbox-wrap"
      }, _react.default.createElement("input", {
        type: "checkbox",
        onChange: this.setShowOnline,
        checked: this.state.showOnline,
        value: this.state.showOnline
      }), _react.default.createElement("span", null)), _react.default.createElement("span", null, "Allow other users to see when I am online.")), _react.default.createElement("input", {
        type: "hidden",
        name: "showOnline",
        id: "showOnline",
        value: this.state.showOnline ? '1' : '0'
      }));
    }
  }]);
  return ShowOnline;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "profile", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "setShowOnline", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "setShowOnline"), _class.prototype)), _class);
var _default = ShowOnline;
exports.default = _default;